import { prepareForSlot } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

const SliderRailSlot = prepareForSlot(function SliderRail(
  props: ComponentProps<'span'>,
): JSX.Element {
  const { className, ...rest } = props

  return <span className={clsx('slider__rail', className)} {...rest} />
})

export const SliderRail = SliderRailSlot
